var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-msg",on:{"click":_vm.goHome}},[_c('h1',[_vm._v("Sorry bro. She ain't here.")]),_c('p',[_c('router-link',{attrs:{"to":{ path: '/' }}},[_vm._v(_vm._s(_vm.msg))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }